import React, { useState,useEffect,useCallback } from "react";
import {
  Box,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Paper,IconButton,
  InputLabel,FormControl
} from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthProvider";
import { InputAdornment } from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { Button, CircularProgress } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StudentMarksUpload = () => {
  const navigate = useNavigate();
  const {oId,pId,board} = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [selectedExam, setSelectedExam] = useState();
  const [examTypes, setExamTypes] = useState([]);
const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState('');
const [sscSelectedSection, setSscSelectedSection] = useState();
const [sscClassSectionMap, setSscClassSectionMap] = useState({});

  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");

     // ✅ Common categories + total marks
  const [students, setStudents] = useState([]);
const [subjects, setSubjects] = useState({}); // { GK: ["SLIP TEST","PROJECT"], Telugu: [...] }
  const [loading, setLoading] = useState(false); // ✅ loading state
  const [btnloading, setBtnLoading] = useState(false);

 // Fetch Examination info dynamic (fa1,fa2)
    const fetchExamTypes = async () => {
      try {
        
        const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsTypes/${oId}/${pId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setExamTypes(data);
      } catch (error) {
        console.error("Error fetching exam types:", error);
        setExamTypes([]);
      } 
    };

 useEffect(() => {
 
    fetchExamTypes();
    fetchClassRegistrationData();

}, [oId,pId]);

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sections.forEach((sec) => classSectionMap[className].add(sec));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
  const defaultClass = classes[0];
  const sectionArray = [...classSectionMap[defaultClass]];

  setSscSelectedClass("");
  setSscSectionOptions(sectionArray);
  setSscSelectedSection(sectionArray[0] || "");
} else {
  setSscSelectedClass("");
  setSscSectionOptions([]);
  setSscSelectedSection("");
}

    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};

     //select subject api 
     const fetchSubjectOptions = async () => {
      try {
        const selectedClass = sscSelectedClass;
        if (!selectedClass) return;
        let response;
    
        if (board === "SSC") {
          response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${selectedClass}`);
        }
    
        if (!response) return;
    
        const data = await response.json();
    
        if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
          const subjectsArray = data[0].split(',').map((name, index) => ({
            id: index + 1,
            name: name.trim(),
          }));
          setSubjectOptions(subjectsArray);
        } else {
          setSubjectOptions([]);
        }
      } catch (error) {
        console.error("Error fetching subject options:", error);
        setSubjectOptions([]);
      }
    };
    
    
    useEffect(() => {
      if (oId && (sscSelectedClass)) {
        fetchSubjectOptions();
      }
    }, [oId, sscSelectedClass]); // Add selectedClass dependencies
    
const StudentsfetchData = async () => {
  try {
    setLoading(true);

    const response = await fetch(
      `${baseUrl}/api/dynamicMarks/beforeUploadMarksDetails/${pId}/${oId}?romanNumberClass=${sscSelectedClass}&examType=${selectedExam}&section=${sscSelectedSection}&subjects=${selectedSubject}`
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();

    // Build subject -> categories map
    const subjectsMap = {};
    data.forEach((stu) => {
      stu.subjects.forEach((subj) => {
        if (!subjectsMap[subj.subject]) subjectsMap[subj.subject] = [];
        subj.categories.forEach((cat) => {
          if (!subjectsMap[subj.subject].some(c => c.subjectsCategory === cat.subjectsCategory)) {
            subjectsMap[subj.subject].push(cat);
          }
        });
      });
    });

    // Format each student’s marks
    const formattedStudents = data.map((stu) => {
      const obtainedMarks = {};

      stu.subjects.forEach((subj) => {
        subj.categories.forEach((cat) => {
          obtainedMarks[`${subj.subject}_${cat.subjectsCategory}`] = cat.obtainedMarks || "";
        });
        obtainedMarks[subj.subject] = subj.marks || ""; // ✅ subject-level marks
      });

      return {
        studentId: stu.studentId,
        studentRollNumber: stu.studentRollNumber,
        studentName: stu.studentName,
        admissionNumber: stu.admissionNumber || "",
        customAdmissionNumber: stu.customAdmissionNumber || "",
        overallGrade: stu.overallGrade,
        totalMarks: stu.totalMarks,
        obtained: obtainedMarks,
        subjects: stu.subjects, // keep original structure for totals
      };
    });

    // ✅ SORT BY studentRollNumber (ASCENDING ORDER)
      formattedStudents.sort((a, b) => {
        return Number(a.studentRollNumber) - Number(b.studentRollNumber);
      });

    setStudents(formattedStudents);
    setSubjects(subjectsMap);
  } catch (err) {
    console.error("❌ Error fetching data:", err);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  // ✅ Only fetch when all values are selected
  if (pId && sscSelectedClass && selectedExam && selectedSubject && sscSelectedSection) {
    StudentsfetchData();
  }
}, [pId, sscSelectedClass, selectedExam, selectedSubject,sscSelectedSection]);
  // ✅ Handle obtained marks change

const handleMarksChange = useCallback(
  (studentId, key, value, totalMarks) => {
    if (isNaN(value)) return;

    let marks = Number(value);
    if (marks < 0) marks = 0;
    if (marks > totalMarks) marks = totalMarks;

    setStudents((prev) =>
      prev.map((stu) => {
        if (stu.studentId !== studentId) return stu;

        const updatedObtained = { ...stu.obtained, [key]: marks };

        // ✅ Case 1: Category field (e.g., Telugu_Internal)
        if (key.includes("_")) {
          const subjectName = key.split("_")[0];
          let subjectTotal = 0;

          Object.entries(updatedObtained).forEach(([k, v]) => {
            if (k.startsWith(subjectName + "_")) {
              subjectTotal += Number(v) || 0;
            }
          });

          updatedObtained[subjectName] = subjectTotal;
        }
        return { ...stu, obtained: updatedObtained };
      })
    );
  },
  [] // stable reference
);

const handleSubmit = async () => {
  if (!sscSelectedClass || !sscSelectedSection || !selectedSubject) {
    toast.error("Please select class, section and subject!");
    return;
  }

  setBtnLoading(true);

  const payload = students.map((stu) => {
    // find selected subject for this student
    const subj = stu.subjects?.find((s) => s.subject === selectedSubject);

    return {
      studentId: stu.studentId,
      // ✅ overall subject marks
      marks: stu.obtained?.[selectedSubject] || "",

      // ✅ ensure categories come from THIS student's subject, not globally
      subjectCategories: subj
        ? subj.categories.map((cat) => ({
            subjectsCategory: cat.subjectsCategory,
            totalMarks: cat.totalMarks,
            obtainedMarks:
              stu.obtained?.[`${selectedSubject}_${cat.subjectsCategory}`] || "",
          }))
        : [],
    };
  });

  try {
    const res = await fetch(
      `${baseUrl}/api/subjectMarks/upload/allStudent/${oId}/${pId}?subject=${selectedSubject}&examType=${selectedExam}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const text = await res.text();

    if (res.ok) {
      toast.success(text || "Marks submitted successfully!");
    } else {
      toast.error(text || `Failed to submit: ${res.status}`);
    }
  } catch (err) {
    toast.error("Something went wrong! Please try again.");
  } finally {
    setBtnLoading(false);
  }
};







  return (
    <Box 
    display="flex" 
    p={2} 
    gap={2} 
    marginTop="4%"
    // height="100vh"
    >
      {/* Left Exam Menu */}
      <Paper
        sx={{
          width: 100,
          p: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
        elevation={3}
      >
        {/* Left side: Back button + heading */}
          <Box display="flex" alignItems="center">
            <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
              <KeyboardBackspaceIcon fontSize="medium" />
            </IconButton>
            <Typography
              variant="h5"
              component="h3"
              sx={{ fontWeight: 'bold' }}
            >
              Exam
            </Typography>
          </Box>
        
        {examTypes.map((exam) => (
          <Button
  key={exam}
  variant={selectedExam === exam ? "contained" : "outlined"}
  onClick={() => setSelectedExam(exam)}
  sx={{
    bgcolor: selectedExam === exam ? "#3C3972" : "transparent",
    color: selectedExam === exam ? "#fff" : "#3C3972",
    fontWeight:'bold',
    borderColor: "#3C3972",
    "&:hover": {
      bgcolor: selectedExam === exam ? "#2c2a56" : "#f0f0f0",
      borderColor: "#3C3972",
    },
  }}
>
  {exam}
</Button>

        ))}
      </Paper>

      {/* Main Content */}
      <Paper sx={{ flex: 1, p: 2 }} elevation={3}>
         <Typography
              variant="h4"
              component="h3"
              sx={{ fontWeight: 'bold',textAlign:'center',paddingBottom:'15px' }}
            >
              Upload Students Marks
            </Typography>
        {/* Top Row */}
        <Box display="flex" gap={2} mb={2}>
       {/* //class section formcontrols */}
          {board === "SSC" && (
                          <>
                            <FormControl fullWidth>
                              <InputLabel id="class-select-label">Select Class</InputLabel>
                              <Select
                                labelId="class-select-label"
                                value={sscSelectedClass}
onChange={(e) => {
  const selectedClass = e.target.value;
  setSscSelectedClass(selectedClass);

  // Directly get sections from map
  const sectionsForClass = sscClassSectionMap[selectedClass]
    ? Array.from(sscClassSectionMap[selectedClass])
    : [];

  // Set both options & default section right away
  setSscSectionOptions(sectionsForClass);
  setSscSelectedSection(sectionsForClass[0] || "");
}}


                 
                                label="Select Class"
                                // sx={{ height: 35 }}
                              >
                                {sscClassOptions.map((cls) => (
                                  <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                        
                            <FormControl fullWidth>
                              <InputLabel id="section-select-label">Select Section</InputLabel>
                              <Select
                                labelId="section-select-label"
                                value={sscSelectedSection}
                                onChange={(e) => setSscSelectedSection(e.target.value)}
                                label="Select Section"
                                // sx={{ height: 35 }}
                                disabled={sscSectionOptions.length === 0}
                              >
                                {sscSectionOptions.map((section) => (
                                  <MenuItem key={section} value={section}>{section}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </>
                        )}

                        <FormControl fullWidth>
                          <InputLabel>Select Subject</InputLabel>
                          <Select
                            name="subject"
                            value={selectedSubject}
                            onChange={(e) => setSelectedSubject(e.target.value)}
                            label="Select Subject"
                          >
                            {subjectOptions.length > 0 ? (
                              subjectOptions.map((subject) => (
                                <MenuItem key={subject.id} value={subject.name}>
                                  {subject.name}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled value="">
                                {board === "INTERMEDIATE"
                                  ? "No available subjects for selected Year and Course"
                                  : "No available subjects for selected Class"}
                              </MenuItem>
                            )}
                          </Select>
                         
                        </FormControl>
        </Box>


        {/* Title */}
       <Box display="flex" justifyContent="flex-start" mb={2} gap={2}>
  <Typography variant="h6" >
    Selected Exam Type:{" "}
    <Typography component="span" fontWeight="bold">
      {selectedExam || "None"}
    </Typography>
  </Typography>

  <Typography variant="h6">
    Selected Subject:{" "}
    <Typography component="span" fontWeight="bold">
      {selectedSubject || "None"}
    </Typography>
  </Typography>
</Box>
 <GlobalStyles
                            styles={{
                              '.custom-sidebar-scrollbar': {
                                scrollbarWidth: 'thin', // For Firefox
                                scrollbarColor: 'grey #e0e0e0',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                                width: '6px', // For WebKit-based browsers
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                                background: '#f1f1f1', // Track color
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                                backgroundColor: 'grey', // Thumb color
                                borderRadius: '10px',
                              },
                              '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: '#555',
                              },
                            }}
                          />

        {/* Students Marks List */}
      <Box
      sx={{
        maxHeight: "60vh",
        overflowY: "auto",
        padding: "2px 8px 5px 8px",
        border: "1px solid #ccc",
        borderRadius: 2,
      }}
          className="custom-sidebar-scrollbar"
    >
{/* ✅ Fixed Header */}
<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bgcolor: "#f0f0f0", // ash/gray background
    p: 1,
    borderRadius: 1,
    boxShadow: 2,
    mb: 2,
    position: "sticky",
    top: 0,
    zIndex: 20, // ensure above students
  }}
>
  {/* Left - Student Details */}
  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
    Student Details
  </Typography>

  {/* Center - Enter Marks */}
  <Typography
    variant="body1"
    sx={{ fontWeight: "bold", textAlign: "center", flex: 1 }}
  >
    Enter Marks
  </Typography>

</Box>
    {loading ? (
  // ✅ Show loader in center
  <Box display="flex" flexDirection="column" alignItems="center" py={4}>
    <CircularProgress />
    <Typography variant="subtitle1" sx={{ mt: 2 }}>
      Loading student data...
    </Typography>
  </Box>
) : students.length === 0 ? (
  // ✅ No students case
  <Box display="flex" justifyContent="center" alignItems="center" py={4}>
    <Typography variant="subtitle1" color="textSecondary">
      No students data found
    </Typography>
  </Box>
) : (
  // ✅ Show students when available
       <Box sx={{ width: "100%" }}>
  {students.map((student) => (
    <Paper key={student.studentId} sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={2} alignItems="flex-start">
        
        {/* ✅ Left side: Roll Number + Name */}
        <Grid item xs={12} sm={2}>
          {/* Roll No */}
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Roll No:
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              {student.studentRollNumber}
            </Typography>
          </Box>

          {/* Student Name */}
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Name:
            </Typography>
            <Typography variant="body1">{student.studentName}</Typography>
          </Box>
        </Grid>

        {/* ✅ Right side: Subjects + Categories */}
        <Grid item xs={12} sm={10}>
          <Grid container spacing={2}>
            {Object.entries(subjects).map(([subjectName, categories]) => (
              <React.Fragment key={subjectName}>
                {categories.map((cat) => (
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    key={`${subjectName}_${cat.subjectsCategory}`}
                  >
                    {/* <TextField
  fullWidth
  size="small"
  label={cat.subjectsCategory}
  value={
    student.obtained[`${subjectName}_${cat.subjectsCategory}`] ?? ""
  }
  onChange={(e) => {
    const raw = e.target.value;
    const cleaned = raw.replace(/[^0-9.]/g, ""); // allow only digits + decimal point
    if (/^\d*\.?\d*$/.test(cleaned)) {           // valid decimal format
      handleMarksChange(
        student.studentId,
        `${subjectName}_${cat.subjectsCategory}`,
        cleaned,
        cat.totalMarks
      );
    }
  }}
  type="number"
  inputProps={{
    inputMode: "decimal", // ✅ supports decimal keyboard
    pattern: "\\d*\\.?\\d*", // ✅ allow float
    min: 0,
    max: cat.totalMarks,
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <Box sx={{ fontWeight: "bold", fontSize: "1rem" }}>
          /{cat.totalMarks}
        </Box>
      </InputAdornment>
    ),
  }}
/> */}

<TextField
  fullWidth
  size="small"
  label={cat.subjectsCategory}
  value={
    student.obtained[`${subjectName}_${cat.subjectsCategory}`] ?? ""
  }
  onChange={(e) => {
    const raw = e.target.value;
    // Accept empty or valid decimals
    if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
      handleMarksChange(
        student.studentId,
        `${subjectName}_${cat.subjectsCategory}`,
        raw,
        cat.totalMarks
      );
    }
  }}
  type="number"
  inputProps={{
    inputMode: "decimal",    // enables decimal keyboard in mobile
    step: "any",             // allows any decimal input
    pattern: "\\d*\\.?\\d*", // allows float validation
    min: 0,
    max: cat.totalMarks,
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <Box sx={{ fontWeight: "bold", fontSize: "1rem" }}>
          /{cat.totalMarks}
        </Box>
      </InputAdornment>
    ),
  }}
/>




                  </Grid>
                ))}

                {/* ✅ Subject overall - now editable */}
<Grid item xs={12} sm={3}>
<TextField
  fullWidth
  size="small"
  label={`${subjectName} (Overall)`}
  value={student.obtained[subjectName] ?? ""}
  type="number"
  onChange={(e) => {
    const raw = e.target.value;
    // Accept empty or valid decimals
    if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
      handleMarksChange(
        student.studentId,
        subjectName,
        raw,
        student.subjects.find((s) => s.subject === subjectName)?.subjectMarks || 0
      );
    }
  }}
  inputProps={{
    inputMode: "decimal", // shows numeric keyboard on mobile
    step: "any",          // allows any decimal
    pattern: "\\d*\\.?\\d*",
    min: 0,
    max:
      student.subjects.find((s) => s.subject === subjectName)?.subjectMarks ||
      0,
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <Box sx={{ fontWeight: "bold", fontSize: "1rem" }}>
          /
          {
            student.subjects.find((s) => s.subject === subjectName)
              ?.subjectMarks
          }
        </Box>
      </InputAdornment>
    ),
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f6ff",
      borderRadius: "10px",
      "& fieldset": {
        borderColor: "#3C3972",
        borderWidth: "2px",
      },
      "&:hover fieldset": {
        borderColor: "#6a5acd",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ff9800",
        boxShadow: "0 0 6px rgba(255,152,0,0.6)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#3C3972",
      fontWeight: "bold",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#ff9800",
    },
  }}
/>






</Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  ))}
</Box>

      )}
    </Box>

        {/* Submit Button */}
        <Box mt={2} textAlign="right">
        <Button
  onClick={handleSubmit}
  disabled={!sscSelectedClass || !sscSelectedSection || !selectedSubject || btnloading}
  sx={{
    bgcolor: "#3C3972",
    color: "#f0f0f0",
    fontWeight: "bold",
    "&:hover": {
      bgcolor: "#2c2a56",
    },
    "&.Mui-disabled": {
      bgcolor: "#b0b0b0",
      color: "#ffffff",
    },
  }}
>
  {btnloading ? (
    <CircularProgress size={24} sx={{ color: "#fff" }} />
  ) : (
    "Submit Marks"
  )}
</Button>
        </Box>
      </Paper>
      <ToastContainer  position="top-right" autoClose={1000}/>
    </Box>
  );
};

export default StudentMarksUpload;
